var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      !_vm.hideApprovalStati
        ? _c("div", { staticClass: "form-group" }, [
            _c("label", [
              _vm._v(
                _vm._s(_vm.$t("survey.group.model.collectiveApprovalState"))
              )
            ]),
            _vm._v(" "),
            _c("div", [
              _vm.group.collectiveApprovalState === _vm.ApprovalState.Unknown
                ? _c("span", [_c("i", { staticClass: "fa fa-question" })])
                : _vm.group.collectiveApprovalState ===
                  _vm.ApprovalState.Approved
                ? _c("span", { staticClass: "text-success" }, [
                    _c("i", { staticClass: "fa fa-check" })
                  ])
                : _vm.group.collectiveApprovalState ===
                  _vm.ApprovalState.Rejected
                ? _c("span", { staticClass: "text-danger" }, [
                    _c("i", { staticClass: "fa fa-times" })
                  ])
                : _vm.group.collectiveApprovalState ===
                  _vm.ApprovalState.NotRequired
                ? _c("span", [_c("i", { staticClass: "fa fa-minus" })])
                : _c("span", [_vm._v("???")]),
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t(
                      "survey.group.approvalStates." +
                        _vm.camelCase(
                          _vm.ApprovalState[_vm.group.collectiveApprovalState]
                        )
                    )
                  ) +
                  "\n    "
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.group.approvals, function(approval) {
        return _c("div", { key: approval.id, staticClass: "card mb-3" }, [
          _c(
            "div",
            { staticClass: "card-body d-flex flex-row align-items-start" },
            [
              _c("Approval", {
                staticClass: "flex-grow-1",
                attrs: {
                  group: _vm.group,
                  approval: approval,
                  approvalGroups: _vm.approvalGroups,
                  hideApprovalStatus: _vm.hideApprovalStati
                }
              }),
              _vm._v(" "),
              _c("i", {
                staticClass: "fa fa-times ml-3 c-pointer",
                on: {
                  click: function($event) {
                    return _vm.removeApproval(approval)
                  }
                }
              })
            ],
            1
          )
        ])
      }),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex flex-row justify-content-start mt-2" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-success px-4",
            on: { click: _vm.addApproval }
          },
          [_c("i", { staticClass: "fa fa-plus" })]
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }